import { idleDriverSummary } from '@evi/shared';
import type { TFunction } from 'i18next';

export function idleDisclosure(rates: { time_rate?: number | null; idle_grace_minutes?: number | null;
  idle_max_charge_cents?: number | null }, currency?: string, locale?: string, t?: TFunction): string {
  void t; // The shared eleven-locale copy also serves Admin and the manual.
  return idleDriverSummary(rates, currency, locale);
}
